import React, { useContext } from 'react';

import { DataContext } from '../contexts/DataContext';
import CountryPage from './RegistrationSteps.js/CountryPage';
import PhoneNumberPage from './RegistrationSteps.js/PhoneNumberPage';
import SmsConfirmationPage from './RegistrationSteps.js/SmsConfirmationPage';
import FirstNamePage from './RegistrationSteps.js/FirstNamePage';
import LastNamePage from './RegistrationSteps.js/LastNamePage';
import DobPage from './RegistrationSteps.js/DobPage';
import ZipPage from './RegistrationSteps.js/ZipPage';
import EmailPage from './RegistrationSteps.js/EmailPage';
import SubmitPage from './RegistrationSteps.js/SubmitPage';
import DevicesPage from './RegistrationSteps.js/DevicesPage';
import FinishPage from './RegistrationSteps.js/FinishPage';

const StepsPages = [
  CountryPage,
  PhoneNumberPage,
  SmsConfirmationPage,
  FirstNamePage,
  LastNamePage,

  ZipPage,
  DobPage,
  EmailPage,
  SubmitPage,
  DevicesPage,
  FinishPage,
];
function RegistrationPage() {
  const { currentStep /*, setCurrentStep, setData, data*/ } =
    useContext(DataContext);

  const PageComponent = StepsPages[currentStep];
  /*
  const { smsCode } = useParams();
  const [loading, setLoading] = useState(smsCode?.length > 0);
  const checkCode = async () => {
    if (smsCode?.length) {
      setLoading(true);

      try {
        LuxService.validatePhoneNumber(smsCode)
          .then((response) => {
            if (response.status === 'ok') {
              setCurrentStep(3);
              setData({
                ...data,
                country: 'luxembourg',
                phonenumber: response?.data?.phone_number,
              });
            } else {
              setCurrentStep(0);
            }
          })
          .catch((err) => {
            setCurrentStep(0);
          });
      } catch (err) {
        setCurrentStep(0);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    checkCode();
  });
  if (loading) return <></>;*/

  return <PageComponent />;
}

export default RegistrationPage;
